import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { InAppBrowser } from '@ionic-native/in-app-browser';

import { NewsReadPage } from '../news-read/news-read';

import * as moment from 'moment';
import 'moment/locale/de';
/**
 * Generated class for the NewsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-news',
  templateUrl: 'news.html',
})
export class NewsPage {
  title: string = 'News';
  news: any;
  category: any;
  showType = 'slider';
  actCat = '';
  constructor(public navCtrl: NavController, public navParams: NavParams, public teamappProvider: TeamappProvider, public userProvider: UserProvider, private iab: InAppBrowser) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }
      this.loadNews();
  }

  loadNews() {
    this.teamappProvider.http_request(null, 'news', false).then(data => {
      this.news = data;
      if(this.news) {
        this.category = this.news[0].name;
        this.actCat = this.news[0].name;
      }
    });
  }

  clickOnPill(pill: any) {
      this.actCat = pill;
  }
  openNews(news: any) {
      console.log(news);
      if(news.type == 'rss') {
        this.iab.create(news.link, '_blank');
      } else if(news.type == 'own') {
        this.navCtrl.push(NewsReadPage,{news: news});
      }
  }

  getFormattedDate(date: any) {
    let dates = [
        moment(date).format("DD"),
        moment(date).format("MMM")
    ];
    return dates;
  }


  formatNewsDate(date: any) {
    return moment(date).format('DD.MM.YYYY');
  }

  refreshNews(event:any){
    this.news = '';
    this.loadNews();
    event.complete();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/news/news.ts